<template>
    <div>
        <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="barcode-modal" aria-hidden="true" id="barcode-reader-modal">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title">Lecture automatique de code barre</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    
                    <div class="modal-body">
                        <div id="sourceSelectPanel" style="display:none">
                            <div class="form-group mb-4">
                                <label>Choisssez une source vidéo</label>
                                <select id="sourceSelect" class="form-control"></select>
                            </div>
                            <input type="hidden" value="" id="input-target">
                        </div>

                        <div>
                            <video id="video" width="100%" style="border: 1px solid gray"></video>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- Champ de recherche unifié (lot OU intervention) -->
        <div class="row" v-if="init.selectedLot == null && init.selectedIntervention == null">
            <div class="col-sm-12">
                <div class="form-group">
                    <label for="search">Numéro de lot ou de rapport d'intervention</label>
                    <div class="input-group">
                        <input type="search"
                               class="form-control form-control-lg"
                               placeholder='Appuyer sur "Entrer" après la saisie'
                               v-model="init.query"
                               @keyup.enter="searchAll()"
                               id="search">
                        <div class="input-group-append">
                            <button class="ix-btn ix-btn-icon blue barcode-trigger" type="button" data-target-input-id="search">
                                <i class="far fa-barcode-read"></i>
                            </button>
                        </div>
                    </div>
                    <small class="form-text text-muted">
                        Recherche simultanée dans les lots de production et les rapports d'intervention (numéro, désignation, affaire ou équipement).
                    </small>
                </div>

                <div v-if="init.results !== null">
                    <h3 v-if="init.results.length > 0 && !loadingSearch" class="ix-page-title-tertiary mt-3">
                        Choisissez la cible de votre pointage
                    </h3>

                    <div v-for="(r, index) in init.results"
                         :key="r.type + '-' + r.id"
                         @click="selectResultByIndex(index)"
                         class="ix-checking-scan-lot-preview selectable ix-scan-result">

                        <span class="ix-scan-type-badge" :class="'is-' + r.type">
                            <i :class="r.type === 'lot' ? 'far fa-boxes' : 'far fa-wrench'"></i>
                            {{ r.type === 'lot' ? 'Lot' : 'Maintenance' }}
                        </span>

                        <div class="ix-checking-scan-lot-preview-left">
                            <!-- Lot -->
                            <template v-if="r.type === 'lot'">
                                <span class="ix-checking-scan-lot-preview-designation">
                                    {{ r.designation }} <i class="far fa-cube"></i> {{ r.quantity }}
                                </span>
                                <span class="ix-checking-scan-lot-preview-deal">{{ r.deal.designation }}</span>
                                <span class="badge" v-if="r.to_control"
                                      :class="{'badge-warning': r.to_control == 1, 'badge-danger': r.to_control == 2}">
                                    <i class="far fa-exclamation-circle"></i>
                                    Contrôle qualité {{ r.to_control == 2 ? 'exigé' : 'demandé' }}
                                </span>
                            </template>

                            <!-- Intervention -->
                            <template v-else>
                                <span class="ix-checking-scan-lot-preview-designation">{{ r.designation }}</span>
                                <span class="ix-checking-scan-lot-preview-deal">{{ r.equipment.name }}</span>
                            </template>
                        </div>

                        <div class="ix-text-large">
                            <button class="ix-btn ix-btn-icon blue">
                                <i class="fas fa-angle-right"></i>
                            </button>
                        </div>
                    </div>

                    <span v-if="init.results.length == 0 && !loadingSearch">Aucun résultat pour cette recherche</span>
                    <span v-if="loadingSearch">
                        <i class="far fa-circle-notch fa-spin"></i> Recherche en cours ...
                    </span>
                </div>
            </div>
        </div>

        <!-- Aperçu Lot sélectionné -->
        <div class="row" v-if="init.selectedLot != null">
            <div class="col-sm-12">
                <div class="ix-checking-scan-lot-preview">
                    <div class="ix-checking-scan-lot-preview-left">
                        <span class="ix-checking-scan-lot-preview-designation">{{ init.selectedLot.designation }} <i class="far fa-cube"></i>{{ init.selectedLot.quantity }}</span>
                        <span class="ix-checking-scan-lot-preview-deal">{{ init.selectedLot.deal.designation }}</span>
                        <span class="badge" v-if="init.selectedLot.to_control" v-bind:class="{'badge-warning': init.selectedLot.to_control == 1, 'badge-danger': init.selectedLot.to_control == 2}">
                            <i class="far fa-exclamation-circle"></i> Contrôle qualité {{ init.selectedLot.to_control == 2 ? 'exigé' : 'demandé' }}
                        </span>
                    </div>
                </div>

                <div class="form-group">
                    <label for="selectedOperation">Opération concernée</label>
                    <select class="form-control form-control-lg" v-model="init.selectedOperation" id="selectedOperation">
                        <option :value="operation.id" v-for="(operation, index) in init.selectedLot.operations" v-bind:key="index">{{ operation.designation }}</option>
                    </select>
                </div>

                <button class="ix-btn ix-btn-large ix-btn-block" @click="cancelSelectedLot()" :disabled="loadingForm"><i class="far fa-exchange"></i> Changer de cible</button>
                <button class="ix-btn ix-btn-large blue ix-btn-block mt-2" @click="initPrechecking()" :disabled="loadingForm">
                    <span v-if="!loadingForm"><i class="far fa-play"></i> Démarrer</span>
                    <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i> Initialisation en cours</span>
                </button>
            </div>
        </div>

        <!-- Aperçu Intervention sélectionnée -->
        <div class="row" v-if="init.selectedIntervention != null">
            <div class="col-sm-12">
                <div class="ix-checking-scan-intervention-preview">
                    <div class="ix-checking-scan-intervention-preview-icon">
                        <i class="far fa-wrench"></i>
                    </div>
                    <div class="ix-checking-scan-intervention-preview-left">
                        <span class="ix-checking-scan-intervention-preview-designation">
                            {{ init.selectedIntervention.designation }}
                        </span>
                        <span class="ix-checking-scan-intervention-preview-equipment">
                            <i class="far fa-cogs"></i>
                            {{ init.selectedIntervention.equipment.name }}
                            </span>
                        </div>
                    </div>

                <button class="ix-btn ix-btn-large ix-btn-block" @click="cancelSelectedIntervention()" :disabled="loadingForm"><i class="far fa-exchange"></i> Changer de cible</button>
                <button class="ix-btn ix-btn-large blue ix-btn-block mt-2" @click="initPrechecking()" :disabled="loadingForm">
                    <span v-if="!loadingForm"><i class="far fa-play"></i> Démarrer</span>
                    <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i> Initialisation en cours</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from "sweetalert2";

    export default {
        name: 'init-scan-checking-form',
        props: ['lotsRoute', 'initRoute', 'interventionsRoute', 'searchRoute'],
        data() {
            return {
                init: {
                    query: '',
                    results: null,
                    selectedLot: null,
                    selectedOperation: null,
                    selectedIntervention: null,
                },

                loadingSearch: false,
                loadingForm: false,
            };
        },
        methods : {
            searchAll: function() {
                if (!this.init.query) return;

                this.loadingSearch = true;
                this.init.results = [];

                fetch(this.searchRoute + '?q=' + encodeURIComponent(this.init.query), {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    this.loadingSearch = false;
                    if (response.status == 200) {
                        response.json().then((data) => {
                            this.init.results = data;

                            if (data.length == 1) {
                                this.selectResultByIndex(0);
                            }
                        });
                    }
                }).catch(error => {
                    this.loadingSearch = false;
                    console.log(error);
                });
            },
            selectResultByIndex: function(index) {
                const r = this.init.results[index];
                if (!r) return;

                if (r.type === 'lot') {
                    // Le payload "data" contient la Resource Lot complète (avec operations)
                    this.selectLot(r.data);
                } else if (r.type === 'intervention') {
                    this.init.selectedIntervention = r.data;
                }
            },
            selectLot: function(lot) {
                this.init.selectedLot = lot;

                // Choix de l'opération par défaut (celle en cours ou première en attente)
                if (lot.operations && lot.operations.length > 0) {
                    var progressOperationIndex = lot.operations.findIndex((operation) => {
                        return operation.state == 2
                    });

                    if (progressOperationIndex >= 0) {
                        this.init.selectedOperation = lot.operations[progressOperationIndex].id
                    } else {
                        var pendingOperationIndex = lot.operations.findIndex((operation) => {
                            return operation.state == 1
                        });

                        if (pendingOperationIndex >= 0) {
                            this.init.selectedOperation = lot.operations[pendingOperationIndex].id
                        } else {
                            this.init.selectedOperation = lot.operations[0].id
                        }
                    }

                    // Recherche d'une opération à contrôler
                    var operationToControlIndex = lot.operations.findIndex((operation) => {
                        return operation.control_state == 2
                    });

                    if (operationToControlIndex >= 0) {
                        const operationToControl = lot.operations[operationToControlIndex];
                        const requiredControl = operationToControl.is_control_required ? 'obligatoire' : '';

                        Swal.fire({
                            title: 'Attention !',
                            text:`L'opération "${operationToControl.designation}" attend un contrôle qualité ${requiredControl}. Êtes-vous sûr de vouloir démarrer un pointage sur ce lot ?`,
                            icon: 'warning',
                            showCancelButton: true,
                            cancelButtonText: 'Annuler',
                            confirmButtonText: 'Continuer',
                            reverseButtons: true,
                            heightAuto: false
                        }).then((result) => {
                            if (result.isConfirmed == false) {
                                this.cancelSelectedLot()
                            }
                        });
                    }
                }
            },
            cancelSelectedLot: function() {
                this.init.selectedLot = null;
                this.init.selectedOperation = null;
                this.init.results = null;

                setTimeout(() => {
                    $('#search').focus();
                }, 250);
            },
            cancelSelectedIntervention: function() {
                this.init.selectedIntervention = null;
                this.init.results = null;

                setTimeout(() => {
                    $('#search').focus();
                }, 250);
            },

            initPrechecking: function() {
                this.loadingForm = true

                var data = {
                    operation_id: this.init.selectedOperation ? this.init.selectedOperation : null,
                    intervention_id: this.init.selectedIntervention ? this.init.selectedIntervention.id : null
                }

                fetch(this.initRoute, {
                    ...{
                        method: 'POST',
                        body :  JSON.stringify(data)
                    },
                    ...this.getHttpJsonRequestHeaders(),
                }).then((response) => {
                    if (response.status == 200) {
                        response.json().then((data) => {
                            window.location.href = data.redirect
                        })
                    } else {
                        this.loadingForm = false;
                    }
                }).catch(error => {
                    this.loadingForm = false
                    console.log(error)
                });
            }
        },
        mounted(){
            $('#search').focus();

            // Le scanner de codes-barres pousse la valeur scannée vers l'input #search
            // (cf. resources/js/app.js — événement scanSearchUpdated)
            document.addEventListener('scanSearchUpdated', (e) => {
                this.init.query = e.detail;
                this.searchAll();
            }, false);

            // Compatibilité ascendante : si le scanner cible encore #lot ou #intervention
            document.addEventListener('lotSearchUpdated', (e) => {
                this.init.query = e.detail;
                this.searchAll();
            }, false);

            document.addEventListener('interventionSearchUpdated', (e) => {
                this.init.query = e.detail;
                this.searchAll();
            }, false);
        }
    }
</script>

<style lang="scss" scoped>
/* Badge "Lot" / "Maintenance" affiché sur chaque résultat de recherche */
.ix-scan-result {
    position: relative;
}

.ix-scan-type-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin-right: 14px;
    flex-shrink: 0;

    i {
        font-size: 11px;
    }

    &.is-lot {
        background: rgba(37, 99, 235, 0.12);
        color: #1d4ed8;
    }

    &.is-intervention {
        background: rgba(245, 158, 11, 0.15);
        color: #b45309;
    }
}
</style>
